import React, {
  ChangeEvent,
  FormEvent,
  FunctionComponent,
  useState,
} from "react";
import styled from "styled-components";
import { LoginFormProps } from "../../interfaces/interfaces";
import Input from "./input";
// TO DO - WE DON'T NEED USEUSER ANYMORE
// import useUser from "../../hooks/useAuth/useAuth";
import useAuth from "../../hooks/useAuth";
import StyledButton from "../buttons/button";
import ErrorMessage from "./fields/ErrorMessage";

const LoginForm: FunctionComponent<LoginFormProps> = ({
  className,
  onSuccess,
  onError,
}) => {
  const { logInWithEmail } = useAuth();
  const [errorMessage, setError] = useState<string>();
  const [email, setEmail] = useState("test@email.com");
  const placeholder = "Enter your email here";

  const handleOnSubmit = async (event: FormEvent) => {
    event.preventDefault();
    try {
      await logInWithEmail(email);
      onSuccess && onSuccess();
    } catch (error) {
      if (error instanceof Error) {
        setError(error?.message);
        onError && onError(error?.message);
      }
    }
  };

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    setError(undefined);
    setEmail(event.target.value);
  };
  return (
    <>
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      <StyledLoginForm className={className}>
        <Input
          className="input-wrapper"
          required
          placeholder={placeholder}
          name="login-email"
          id="login-email"
          type="email"
          onChange={handleOnChange}
        />
        <StyledButton onClick={handleOnSubmit} className="submit">
          Login
        </StyledButton>
      </StyledLoginForm>
    </>
  );
};

const StyledLoginForm = styled.div`
  display: grid;
  grid-template-columns: 1fr 200px;
  grid-gap: 15px;

  @media only screen and (min-width: 120px) and (max-width: 767px) {
    display: grid;
    grid-template-columns: 1fr;
  }
`;

export default LoginForm;
